<template>
  <div class="container page">
    <van-nav-bar :title="$t('setting.Filladdress')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()" />
      </template>
    </van-nav-bar>
    <div style="padding: 1rem;">
      <div class="main-box bc-body">
        <div class="label">{{ $t("setting.trccard") }}</div>
        <van-cell-group>
          
          <van-field
            v-model="bank"
            :label="$t('setting.Currency')"
            :placeholder="$t('setting.username_place')"
            disabled
          />
          <van-field
            v-model="opw"
            :label="$t('setting.Withdrawal_address')"
            :placeholder="$t('setting.Withdrawal_place')"
          />
        </van-cell-group>
        <!-- <p>{{ $t("setting.bank_warn") }}</p> -->
      </div>
    </div>
    <van-button class="bindCard" type="default" @click="bindCard()">{{
      $t("setting.bank_ok")
    }}</van-button>
    <van-popup
      v-model="showBank"
      round
      position="bottom"
      :style="{ height: '35%' }"
    >
      <van-picker
        show-toolbar
        :columns="banks"
        @confirm="onConfirm"
        @cancel="onCancel"
        :confirm-button-text="$t('setting.ok')"
        :cancel-button-text="$t('setting.cancel')"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      banks: [],
      showBank: false,
      userInfo: {},
      mobile: "",
      bank: "USDT-TRC20",
      opw: "",
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    bindCard() {
      if (this.opw == '') {
        this.$toast(this.$t("setting.prefect"));
        return false;
      }

      this.$http({
        method: "post",
        data: {
          chain_type: this.bank,
          address: this.opw,
        },
        url: "cryptoBind",
      }).then((res) => {
        console.log('绑定信息',res.data);
        if (res.code === 200) {
          this.$router.push({ path: "/Mine" });
          this.$toast(res.msg);
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    // showSelectBanks() {
    //   this.showBank = true;
    // },
    // getUserInfo() {
    //   this.$http({
    //     method: "get",
    //     url: "user_info",
    //   }).then((res) => {
    //     console.log(res.data);
        
    //     if (res.code === 200) {
    //       this.userInfo = res.data;
    //       this.name = res.data.name;
    //     } else if (res.code === 401) {
    //       this.$toast(res.msg);
    //     }
    //   });
    // },
    onConfirm(value) {
      this.bank = value.text;
      this.bank_code = value.value;
      this.showBank = false;
    },
    onCancel() {
      this.showBank = false;
    },
    // getUserBankInfo() {
    //   this.$http({
    //     method: "get",
    //     url: "user_get_bank",
    //   }).then((res) => {
    //     console.log(res.data);
        
    //     if (res.code === 200) {
    //       if (res.data.is_bank) {
    //         this.is_bind = true;
    //       } else {
    //         this.is_bind = false;
    //       }
    //     } else if (res.code === 401) {
    //       this.$toast(res.msg);
    //     }
    //   });
    // },
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
    } else {
      // this.getUserInfo();
      // this.getBankList();
      // this.getUserBankInfo();
    }
  },
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.less";
::v-deep .van-cell-group {
  background: none;
}
::v-deep .van-field__control{
  color: #ccc;
}
.bc-body {
  padding: 1rem;
  border: 3px solid #ac7254;
  border-radius: 2rem;
}
.van-cell {
  font-size: 32px;
  line-height: 80px;
  background: none;
}
.van-hairline--bottom::after {
  border-bottom-width: 3px;
}
.bankbox {
  padding: 15px;
  color: #000;
  background-color: #fff;
}
.bankbox .title {
  padding: 8px 10px 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 28px;
}
// .main-box {
//   // background: #fff;
// }
.main-box .label {
  padding: 20px;
  font-size: 35px;
  color: #797878;
}
::v-deep .van-picker__toolbar {
  height: 50px;
}
/deep/ .van-picker__cancel,
/deep/ .van-picker__confirm {
  padding: 0 20px;
  font-size: 40px !important;
}
::v-deep .van-picker-column {
  font-size: 40px;
}
.main-box p {
  padding: 0 20px;
  font-size: 30px;
  color: #ee0a24;
}
.bindCard {
  margin: 20px 30px 0;
  height: 80px;
  line-height: 1.22667rem;
  border-radius: 50px;
  color: #fff;
  font-size: 30px;
  font-weight: bolder;
  border: none;
  background: linear-gradient(90deg, #EEC094, #F3C7A2);
}
</style>
